import { z } from 'zod/v4';

import { createdAtSchemaLegacy } from '../../../common/schemas/legacy/created-at';
import { styleBagSchema } from '../../../common/schemas/legacy/style-bag';

import { lineLegacyDataSchema } from './data';
import { lineStylesSchemaLegacy } from './styles';

/**
 * Legacy `line` widget envelope — its only placement (`params: defaultWidgetParams`
 * unmodified, i.e. `type: ['default']`; never `'zero'`/`'specific'`). No `type`
 * discriminator: single shape, created through the plain-widget factory path that
 * never stamps one.
 *
 * `styles` is REQUIRED and typed (the divider has no appearance without it);
 * `mobileStyles` stays the open bag — the widget never writes it, but persisted
 * entities may carry one.
 */
export const lineLegacyDefaultV0Schema = z.object({
    id: z.string(),
    name: z.literal('line'),
    columnId: z.string(),
    structureId: z.string().nullish(),
    displayId: z.string().nullish(),
    createdAt: createdAtSchemaLegacy,
    data: lineLegacyDataSchema,
    styles: lineStylesSchemaLegacy,
    mobileStyles: styleBagSchema.nullish(),
});
